var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 12,
    viewBox: "0 0 11 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.0296 7.46708C5.78956 7.66493 5.54952 7.66493 5.30948 7.46708L1.92072 4.07532C1.72304 3.83507 1.72304 3.59482 1.92072 3.35457C2.16076 3.15672 2.40079 3.15672 2.64083 3.35457L5.66954 6.38595L8.69825 3.35457C8.93828 3.15672 9.17832 3.15672 9.41836 3.35457C9.61604 3.59482 9.61604 3.83507 9.41836 4.07532L6.0296 7.46708Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.6c04d48501fdf9db5769fa6b5a0677ee.svg";
export { ForwardRef as ReactComponent };